// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"8d5f65bc","588":"b6941173","1720":"90c26b7e","3598":"42ba50b1","5246":"b6941173","6981":"b6941173","9248":"b6941173"}[chunkId] + ".chunk.css";
};